import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from './services/guards/login.guard';


const routes: Routes = [
  {
    path: 'authentication/recovery-password/:token',
    loadChildren: () => import('./login/recovery-password/recovery-password.module').then(m => m.RecoveryPasswordModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  { path: 'login', loadChildren: () => import('./login/login/login.module').then(m => m.LoginModule) },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
